import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography } from "antd"
import { Doughnut } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { DONUT_COLORS, doughnutOptions } from "../constants"
import EmptyState from "components/common/EmptyState"
import styles from "../style.module.css"

const { Text } = Typography

export default function BookingsByExperienceWidget({ data, periodLabel }) {
  const { t } = useTranslation()
  // chart_data for donut: { labels, series: [{ name, data }] }
  const rawLabels = data?.labels ?? []
  const series = Array.isArray(data?.series) ? data.series : []
  const rawValues = series[0]?.data ?? []
  const items = rawLabels.map((name, i) => ({ name, value: rawValues[i] ?? 0 })).filter((item) => item.value > 0)
  const total = items.reduce((sum, item) => sum + item.value, 0)

  const chartData = {
    labels: items.map((item) => item.name),
    datasets: [{
      data: items.map((item) => item.value),
      backgroundColor: items.map((_, i) => DONUT_COLORS[i % DONUT_COLORS.length]),
      borderWidth: 0,
      hoverOffset: 4
    }]
  }

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="center" className={styles.widgetHeader}>
        <Text strong>{t("ai_dashboard.widget_bookings_by_experience")}</Text>
        <span className={styles.periodTag}>{periodLabel}</span>
      </Flex>
      {items.length === 0
        ? <div className={styles.widgetEmptyState}><EmptyState title={t("ai_dashboard.no_data")} description=" " /></div>
        : (
          <>
            <Text type="secondary" className={styles.textPeriodInfo}>{total} {t("ai_dashboard.booked")} {t("ai_dashboard.during_period")}</Text>
            <Flex align="center" gap="var(--spacing-m)" className={styles.donutWrapper}>
              <div className={styles.donutChart}>
                <Doughnut data={chartData} options={doughnutOptions} />
              </div>
              <Flex vertical gap={6} className={styles.donutLegend}>
                {items.map((item, i) => (
                  <Flex key={item.name ?? i} align="center" gap={6} className={styles.legendItem}>
                    <div className={styles.legendDot} style={{ background: DONUT_COLORS[i % DONUT_COLORS.length] }} />
                    <Text className={styles.legendLabel}>{item.name}</Text>
                    <Text className={styles.textSm}>{total > 0 ? Math.round((item.value / total) * 100) : 0}%</Text>
                  </Flex>
                ))}
              </Flex>
            </Flex>
          </>
        )
      }
    </div>
  )
}

BookingsByExperienceWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  periodLabel: PropTypes.string,
}
